import { application } from "./application"

const modules = import.meta.glob("./*_controller.js", { eager: true })

for (const path in modules) {
  const match = path.match(/\.\/(.+)_controller\.js$/)
  if (!match) continue
  const name = match[1].replace(/_/g, "-")
  application.register(name, modules[path].default)
}
